let storeInstance = null;

export function createStore() {
  if (!storeInstance) {
    let state = $state({
      isConnectedToHotspot: false,
      macAddress: null,
      loading: true,
      loadingIndicator: false,
      node: "",
      isAuthenticatedOnHotspot: false,
      cellphone: null,
      pinLoginNotice: null,
      hotspotPin: null,
      state: "LANDING",
    });

    storeInstance = {
      get store() {
        return state;
      },
      setState(newState) {
        state.state = newState;
      },
      get state() {
        return state.state;
      },
      get cellphone() {
        return state.cellphone;
      },
      setCellphone(cellphone) {
        if (state.cellphone !== cellphone) state.hotspotPin = null;
        console.log("Setting cellphone to", cellphone);
        state.cellphone = cellphone;
      },
      get pinLoginNotice() {
        return state.pinLoginNotice;
      },
      setPinLoginNotice(message) {
        state.pinLoginNotice = message;
      },
      get hotspotPin() {
        return state.hotspotPin;
      },
      setHotspotPin(pin) {
        // Only retain a verified PIN in memory; never persist it in URLs/storage.
        state.hotspotPin = pin;
      },
      get isConnectedToHotspot() {
        return state.isConnectedToHotspot;
      },
      set isConnectedToHotspot(value) {
        state.isConnectedToHotspot = value;
      },
      get macAddress() {
        return state.macAddress;
      },
      set macAddress(value) {
        state.macAddress = value;
      },
      get node() {
        return state.node;
      },
      set node(value) {
        state.node = value;
      },
      get isAuthenticatedOnHotspot() {
        return state.isAuthenticatedOnHotspot;
      },
      set isAuthenticatedOnHotspot(value) {
        state.isAuthenticatedOnHotspot = value;
      },
      get loading() {
        return state.loading;
      },
      set loading(value) {
        state.loading = value;
      },
      async authenticate() {
        let cellphone = state.cellphone;
        let macAddress = state.macAddress;
      },
      get loadingIndicator() {
        return state.loadingIndicator;
      },
      set loadingIndicator(v) {
        state.loadingIndicator = v;
      },
    };
  }
  return storeInstance;
}

export function getStore() {
  if (!storeInstance) {
    storeInstance = createStore();
  }
  return storeInstance;
}

export const store = getStore();
